import { filter } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

@Component({
    selector: 'app-slim-loader',
    templateUrl: './slim-loader.component.html',
    styleUrls: ['./slim-loader.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatProgressBarModule,
    ],
})
export class SlimLoaderComponent implements OnInit
{
    @Input() interval = 500;
    @Input() percent = 0;

    private progressBarInterval: NodeJS.Timer = null;

    constructor(
        private _router: Router,
    ) {
    }

    get loading() {
        return this.percent < 100;
    }

    set loading(isLoading: boolean) {
        if (isLoading) {
            this.percent = 0;
            this.progressBarInterval = setInterval(() => {
                this.percent++;
                if (this.percent >= 100) {
                    clearInterval(this.progressBarInterval);
                }
            }, this.interval);
        } else if (this.progressBarInterval) {
            clearInterval(this.progressBarInterval);
            this.percent = 100;
            this.progressBarInterval = null;
        }
    }

    ngOnInit() {
        /** Currently watch the router for changes and run loader */
        this._router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            this.loading = false;
        });
        this._router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
            this.loading = true;
        });
    }
}
